import styled from "styled-components";

export const TempleteWrappr = styled.div`
    margin-left: 45px;
    font-family: var(--FinanceTempleteWrapprFont-family);
      font-size: 14px;
`
export const ButtonWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
`
export const Button = styled.button`
background-color:#2455ef; 
border:1px solid #2455EF; 
border-color:#2455EF; 
border-radius:20px; 
border-width:1px; 
color:#ffffff; 
display:inline-block;
 font-size:14px; 
 font-weight:normal; 
 letter-spacing:0px; 
 line-height:normal; 
 padding:12px 18px 12px 18px; 
 text-align:center; 
 text-decoration:none; 
 border-style:solid;
`